import directive from './directive';
import filter from './filter';
import plugin from './plugin';

window.VueMask=plugin;

export {
  // eslint-disable-next-line no-restricted-exports
  plugin as default,
  plugin as VueMaskPlugin,
  filter as VueMaskFilter,
  directive as VueMaskDirective,
};
